<div class="breadcrumb-container">
  <div class="row">
    <div class="col-lg-12">
      <h1>Document Management</h1>
      <ol class="breadcrumb" id="breadcrumbNav">
        <li>
          <a [routerLink]="['/home']">
            <i class="fa fa-home"></i>
            <span>ProManual</span>
          </a>
        </li>
        <li class="active">
          <i class="fa fa-list-alt"></i>
          <span>Document Management</span>
        </li>
        <li style="float: right" *ngIf="verificationRunning">
          <a class="btn btn-primary" (click)="verifyDocuments()">
            <i class="fa fa-list-alt"></i>
            <span>Verify Documents with FMI Portal</span>
          </a>
        </li>
      </ol>
    </div>
  </div>
</div>
<div class="component-container heightcls">
  <div class="well" style="height: 100%">
    <fmiproduct-list></fmiproduct-list>
  </div>
</div>

<div
  bsModal
  #verifyDocumentModal="bs-modal"
  class="modal fade"
  [config]="{ keyboard: false, backdrop: 'static' }"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" style="width: 75%">
    <div class="modal-content" data-bind="with: entity">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          aria-hidden="true"
          (click)="cancelVerification()"
        >
          &times;
        </button>
        <h4 class="modal-title" id="myModalLabel">
          <span>Verify Documents with FMI Portal</span>
        </h4>
      </div>
      <div
        class="modal-body"
        data-bind="with: $data.entity"
        style="padding: 8px"
      >
        <div class="row">
          <div class="col-lg-12">
            <span
              >This process will verify all document information contained in
              the ProManual Admin Web Portal matches the information found in
              the FMI Portal. Press Start button to continue...</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <span>&nbsp;</span>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <button
              type="button"
              class="btn btn-success"
              *ngIf="verificationRunning == false"
              (click)="startVerification()"
            >
              Start
            </button>
            <button
              type="submit"
              class="btn btn-default"
              *ngIf="verificationRunning == true"
              (click)="cancelVerification()"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
